<div class="wizard-container" [class.mobile]="isMobile()">
  <!-- Indicador de progresso -->
  <app-search-step-indicator 
    [steps]="steps()"
    [currentStep]="currentStepIndex()"
    [compact]="isMobile()"
    (stepClick)="onStepIndicatorClick($event)">
  </app-search-step-indicator>

  <!-- Hint de swipe para mobile -->
  @if (isMobile() && !isFirstStep() && !isLastStep()) {
    <div class="swipe-hint" [@fadeIn]>
      <mat-icon>swipe</mat-icon>
      <span>Deslize para navegar entre etapas</span>
    </div>
  }

  <!-- Conteúdo do wizard com animação -->
  <div class="wizard-content" [@slideAnimation]="currentStepIndex()">
    <div class="step-content">
      <!-- Conteúdo projetado da etapa atual -->
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Ações do wizard -->
  <div class="wizard-actions" [class.mobile]="isMobile()">
    <div class="actions-left">
      <button 
        mat-button 
        (click)="previousStep()" 
        [disabled]="!wizardConfig().canGoBack"
        class="btn-previous">
        <mat-icon>arrow_back</mat-icon>
        @if (!isMobile()) {
          <span>Anterior</span>
        }
      </button>
    </div>

    <div class="actions-center">
      <!-- Indicador de progresso textual -->
      <span class="progress-text">
        Etapa {{ currentStepIndex() + 1 }} de {{ steps().length }}
      </span>
    </div>

    <div class="actions-right">
      @if (!isLastStep()) {
        <button 
          mat-flat-button 
          color="primary" 
          (click)="nextStep()" 
          [disabled]="!wizardConfig().canProceed"
          class="btn-next">
          @if (!isMobile()) {
            <span>Próximo</span>
          }
          <mat-icon>arrow_forward</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
